import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import * as d3 from 'd3';
import SectionDataVisualizer from './SectionDataVisualizer';

import { getSemester, getCapitalName } from '../common/utils';
import '../styles/CourseDetailWrapper.css';

class CourseDetailWrapper extends Component {
    constructor(props) {
        super(props);
        let term = (props.selectedTerm in props.instructor.sections) ? 
            props.selectedTerm : props.instructor.last_term;
        this.state = { instructor: props.instructor, selectedTerm: term.toString(),
            eidHash: props.eidHash };
    }

    /*
    _getLatestTerm(sections) {
        if (sections) {
            let maxTerm = 0;
            for (let term of Object.keys(sections)) {
                term = parseInt(term);
                if (maxTerm < term) maxTerm = term;
            }
            return maxTerm.toString();
        }
    }
    */

    componentWillReceiveProps(props) {
        if (this.state.eidHash !== props.eidHash)
            this.setState({ instructor: props.instructor, eidHash: props.eidHash,
                selectedTerm: props.instructor.last_term.toString() });
    }
    _createDataArr(section) {
        let result = [];
        let total = section['grade_count'];
        let letters = ['a', 'ab', 'b', 'bc', 'c', 'd', 'f'];
        for (let letter of letters) {
            let key = '_' + letter;
            let count = section[key];
            let freq = (total === 0) ? 0 :  count / total * 100;
            result.push({'letter': letter.toUpperCase(), 'count': count, 'freq': freq});
        }
        return result;
    }

    _formatTitle() {
        let name = this.state.instructor.name;
        name = getCapitalName(name);
        let term = getSemester(this.state.selectedTerm);
        return name + ' - ' + term;
    }

    _selectorOnClick(event) {
        this.setState({ selectedTerm: event.target.value.toString() });
    }

    /* // DOESNT WORK
    _appendSpace(str, count, end) {
        let needed = count - str.length;
        if (needed > 0) str += new Array(needed + 1).join(' ') + end;
        else str += end;
        return str;
    }*/

    _getTermSelector() {
        const sections = this.state.instructor.sections;
        const terms = Object.keys(sections).sort((a, b) => parseInt(b) - parseInt(a));
        const termSelectorOptions = terms.map(term => {
            let semester = getSemester(term);
            if (term.toString() !== this.state.selectedTerm)
                return (<option className="course-detail-term-option" key={ term } value={ term } >{ semester }</option>);
            else return (<option className="course-detail-term-option" key={ term } selected value={ term } >{ semester }</option>);
        });
        return (
            <select id="course-detail-term-selector" onChange={ this._selectorOnClick.bind(this) } >
                { termSelectorOptions }
            </select>
        );
    }

    render() {
        if (!this.state.instructor || !this.state.eidHash) return (<div></div>);
        // console.log(this.state);
        // console.log(JSON.stringify(this.state.sections));
        // this._drawGraph(this.state.sections[this.state.selected]);
        // { this._drawGraph(this.state.sections[this.state.selected]) }
        const section = this.state.instructor.sections[this.state.selectedTerm];
        return (
            <div>
                <div className="course-detail-term-selector-container">
                    { this._getTermSelector() }
                </div>
                <div>
                    <SectionDataVisualizer data={ this._createDataArr(section) }
                        selected={ this._formatTitle() } />
                </div>
                <div className="course-detail-section-info">
                    Avg GPA <b>{ section.average.toFixed(2) } | </b>Count { section.total } ({ section.grade_count })
                </div>
            </div>
        );
    }
}

export default CourseDetailWrapper;



// WEBPACK FOOTER //
// ./src/components/CourseDetailWrapper.js